import { jsx as e, jsxs as C } from "react/jsx-runtime";
import { createStyles as $, rem as t, getStylesRef as n, Box as z, Button as w, Space as B } from "@mantine/core";
import { useWindowEvent as S } from "@mantine/hooks";
import { useRef as k, useState as b, useEffect as v, useCallback as T } from "react";
import "../ProductTileSkeleton.js";
import { IconChevronDown as j } from "../../Icon/icons/ChevronDown.js";
import { IconGift as E } from "../../Icon/icons/Gift.js";
import { IconMoney as L } from "../../Icon/icons/Money.js";
import { IconChevronUp as W } from "../../Icon/icons/ChevronUp.js";
const p = 35, D = $((o) => ({
  container: {
    // The container width needs to be 100% plus the width of spacing 'md'
    // so the right margin of the last button of each row can fit.
    width: `calc(100% + ${o.spacing.md})`,
    minHeight: t(p),
    // Pull the container up to offset top margin on first row of buttons
    marginTop: t(-10),
    marginBottom: o.spacing.lg
  },
  innerContainer: {
    position: "relative"
  },
  collapsed: {
    maxHeight: t(p),
    overflow: "hidden"
  },
  button: {
    height: t(24),
    padding: `${t(3)} ${t(8)}`,
    marginTop: t(10),
    marginRight: o.spacing.md,
    fontWeight: "normal",
    color: o.colors.black,
    borderColor: o.colors.gray[2],
    "&:hover": {
      backgroundColor: o.colors.teal[0]
    },
    "&:active": {
      backgroundColor: o.colors.teal[1]
    }
  },
  active: {
    ref: n("active"),
    backgroundColor: o.colors.teal[0],
    borderColor: o.colors.teal[4]
  },
  soldout: {
    position: "relative",
    color: o.colors.gray[4],
    backgroundColor: o.colors.gray[1],
    borderColor: o.colors.gray[2],
    [`&.${n("active")}`]: {
      borderColor: o.colors.black[2]
    },
    // Strike through sold out button
    "&:after": {
      position: "absolute",
      left: 0,
      top: "45%",
      content: '""',
      display: "block",
      width: "100%",
      height: "1px",
      backgroundColor: o.colors.gray[3],
      transform: "rotate(-15deg)"
    }
  },
  promo: {
    borderColor: o.other.semanticColors.error,
    [`&:hover:not(.${n("active")}):not(:active)`]: {
      borderColor: o.colors.red[2]
    },
    "&:active": {
      borderColor: o.other.semanticColors.error
    }
  },
  promoIcon: {
    position: "absolute",
    top: t(-8),
    right: t(1)
  },
  saleIcon: {
    ref: n("saleIcon"),
    color: o.other.semanticColors.error,
    backgroundColor: o.white,
    borderRadius: "50%"
  },
  giftIcon: {
    ref: n("giftIcon"),
    color: o.colors.orange[4],
    backgroundColor: o.white,
    borderRadius: "50%",
    [`& + .${n("saleIcon")}`]: {
      right: t(15)
    }
  },
  compactButton: {
    paddingLeft: t(4),
    paddingRight: t(2),
    color: o.colors.teal[7],
    borderColor: "transparent"
  },
  // The 'more' button is floated to the right to ensure its always visible on
  // the first row of buttons
  moreButton: {
    float: "right"
  }
})), Q = ({ activeSku: o, onSkuChange: h, skus: I }) => {
  const { classes: r, cx: s } = D(), l = k(null), a = k(null), [d, N] = b(0), [g, x] = b(!1), [c, u] = b(!1), [i, y] = b(!0);
  v(() => {
    !g && I.length && d > p && (x(!0), u(!0));
  }, [g, d, x, I, u]), v(() => {
    g && (l != null && l.current) && l.current.offsetTop > p && y(!1);
  }, [l, g]), v(() => {
    a != null && a.current && !c && N(a.current.clientHeight);
  }, [a, c]);
  const H = T(() => {
    h({ toggle: i ? "more" : "less" }), y(!i);
  }, [i, h]);
  return S("resize", () => {
    u(!1);
  }), v(() => {
    !c && d > p && u(!0);
  }, [d, c]), e(z, { className: s(r.container, { [r.collapsed]: i }), children: C(z, { className: r.innerContainer, ref: a, children: [c && i && C(w, { className: s(r.button, r.compactButton, r.moreButton), onClick: H, color: "teal.6", variant: "subtle", radius: "xs", size: "sm", fw: 700, compact: !0, children: ["More", e(B, { w: "4px" }), e(j, { size: 8 })] }), I.map(({ badge: f, displayName: M, isSoldOut: R, sku: m }) => C(w, { ref: o === m ? l : void 0, className: s(r.button, { [r.active]: o === m }, { [r.soldout]: R }, { [r.promo]: f === "sale" || f === "free-gift" }), variant: "outline", radius: "xs", size: "sm", compact: !0, onClick: () => h({ skuId: m }), children: [M, f === "free-gift" && e(E, { className: s(r.promoIcon, r.giftIcon), size: 12 }), f === "sale" && e(L, { className: s(r.promoIcon, r.saleIcon), size: 12 })] }, m)), c && !i && C(w, { className: s(r.button, r.compactButton), onClick: H, color: "teal.6", variant: "subtle", radius: "xs", size: "sm", fw: 700, compact: !0, children: ["Less", e(B, { w: "4px" }), e(W, { size: 8 })] })] }) });
};
export {
  Q as SkuButtons
};
